module.exports = "<router-outlet *ngIf=\"!loading\"></router-outlet>"